module.exports = __webpack_public_path__ + "img/wa-line3.3a863d6.png";